// extracted by mini-css-extract-plugin
export default {"login":"login_login__eOHiR","inputBox":"login_inputBox__nIr+-"};